// extracted by mini-css-extract-plugin
export var errorIcon = "_lx-1";
export var nameLogo = "_lx-0";